import { render, staticRenderFns } from "./user-identity-input.vue?vue&type=template&id=268cf2eb&lang=pug&"
import script from "./user-identity-input.vue?vue&type=script&lang=js&"
export * from "./user-identity-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports